import styled from 'styled-components';
// lib
import palette from 'lib/styles/palette';
import * as styles from 'lib/styles/styles';

const ControlBtn = ({ message, onClick }: Props) => {
  return <Btn onClick={() => onClick()}>{message}</Btn>;
}

const Btn = styled.button`
  font-size: 1rem;
  font-weight: 600;
  height: 100%;
  padding: 0 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .1s ${styles.transition};
  outline: none;
  &:focus, &:hover {
    color: ${palette.blue0};
  }

  &:first-child {
    margin-left: 8px;
  }
`;

interface Props {
  message: string;
  onClick: (value?: boolean) => void;
}

export default ControlBtn